import type { DashboardMetricStripProps } from './types';

export default function DashboardMetricStrip({ ariaLabel, metrics }: DashboardMetricStripProps) {
  return (
    <ul aria-label={ariaLabel} className="grid grid-cols-2 gap-3 lg:grid-cols-4">
      {metrics.map((metric) => (
        <li key={metric.label} className="min-w-0 rounded-xl bg-white p-4 ring-1 ring-gray-200 dark:bg-gray-900 dark:ring-gray-800">
          <p className="break-words text-2xl font-semibold tabular-nums text-club-navy-950 dark:text-white">{metric.value}</p>
          <p className="mt-1 break-words text-sm font-medium text-gray-700 dark:text-gray-200">{metric.label}</p>
          {metric.context && <p className="mt-1 break-words text-xs text-gray-500 dark:text-gray-400">{metric.context}</p>}
        </li>
      ))}
    </ul>
  );
}
